module.exports = __webpack_public_path__ + "038bca9550264f5548dadae4ad2fe71e.png";